import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app.module';
// import {AuthenticationProvider} from "../providers/authentication/authentication.service"
// import {paytron-backendProvider} from "../providers/paytron-backend/paytron-backend.service"

platformBrowserDynamic().bootstrapModule(AppModule);



// WEBPACK FOOTER //
// ./src/app/main.ts